import React from 'react';

function Form({ form }) {
  if (!form) {
    return 'loading'
  }
  const translations = {
    W: 'V',
    L: 'F',
    D: 'O',
  };
  const classNames = {
    W: 'stats-table__form__win',
    L: 'stats-table__form__lose',
    D: 'stats-table__form__draw',
  };
  return form?.map((item) => (
    <div className={classNames[item?.matchResult]}>
      {translations[item?.matchResult]}
    </div>
  ));
}
export default Form;
